// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "html{content:\"\"}@media (prefers-color-scheme:light){html{content:\"light\"}}@media (prefers-color-scheme:dark){html{content:\"dark\"}}", ""]);
// Exports
module.exports = exports;
